// The tracked endpoint nests one extra level (platform -> track -> builds) while every
// consumer of the agentsBuildsGet slice renders the legacy flat shape
// (platform -> flavor -> build). A user's response carries exactly the one track their
// profile resolves to; an admin's carries every mapped track, where LATEST keeps the
// pre-track behaviour. When LATEST is absent the newest track wins by explicit
// precedence, never by JSON key order. Each build is tagged with the track it came
// from so fleet-wide consumers (the SSO/MDM instructions) can refuse non-LATEST builds.
const TRACK_PRECEDENCE = ["LATEST", "LATEST_1", "LATEST_2"];

export function flattenTrackedBuilds(tracked) {
  const platforms = {};
  Object.entries(tracked || {}).forEach(([name, tracks]) => {
    const trackKeys = Object.keys(tracks || {});
    if (!trackKeys.length) return;
    const track =
      TRACK_PRECEDENCE.find((key) => tracks[key]) || trackKeys[0];
    const builds = tracks[track]?.builds || {};
    platforms[name] = Object.fromEntries(
      Object.entries(builds).map(([flavor, build]) => [
        flavor,
        { ...build, updateTrack: track },
      ])
    );
  });
  return platforms;
}
